/**
 * Utility function for fetching user options based on route context
 */
/**
 * Get user list options based on route (admin vs regular)
 * @param {Object} context - Vue component instance (this)
 * @returns {Promise<Array>} - Promise resolving to array of user options
 */
export async function getUserOptions(context, sites = null) {
    const isAdminRoute = context.$route.matched.some((r) => r.name === 'Admin');

    if (isAdminRoute) {
        await context.$employeesStore.syncConsultants();
        return context.$employeesStore.getConsultantOptions;
    } else {
        return new Promise((resolve) => {
            context.$employeesStore.sync(() => {
                if (sites) {
                    resolve(
                        context.$employeesStore.getEmployeeOptionsBySites(sites)
                    );
                } else {
                    resolve(context.$employeesStore.getEmployeeOptions());
                }
            });
        });
    }
}
